// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-fee-button {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  background-color: #f8f9fa;
  border: 1px solid #ccc;
  font-size: 0.875rem;
  cursor: pointer;
  transition: box-shadow 0.2s;
}

.select-fee-button:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/*Confirmar pagamento*/
.payment-confirmation-container {
  background-color: #f9fafb;
  border-radius: 12px;
  padding: 24px;
  margin-top: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.confirmation-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}

.icon-alert {
  color: #f59e0b;
}

.confirmation-title {
  font-size: 18px;
  font-weight: 600;
  color: #374151;
}

.confirmation-section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 10px;
}

.payment-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.payment-list li {
  padding: 4px 0;
  color: #374151;
}

.totals p {
  font-size: 15px;
  color: #111827;
}

.total-line {
  font-size: 16px;
  font-weight: 700;
  color: #10b981;
}

/*Comprovantes*/
.receipt-list {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.receipt-item {
  position: relative;
  width: 300px;
  height: 300px;
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.receipt-item img {
  width: 200px;
  height: 200px;
}

.receipt-item button {
  background: #f71836;
  border: none;
  border-radius: 50%;
  padding: .75rem;
  cursor: pointer;
}

/* proced. selecionado p/ extorno */
.payment-procedure-item.paid.selected {
  border: 1px solid #d9534f;
  background: rgba(217, 83, 79, 0.1);
}

/* botão extorno */
.confirm-refund-button {
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 8px 14px;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-weight: 500;
  cursor: pointer;
}
/* ---------- Variáveis ---------- */
:root {
  --c-bg: #ffffff;
  --c-bg-alt: #f6f8fa;
  --c-primary: #2563eb; /* azul */
  --c-primary-light: #3b82f6;
  --c-danger: #d9534f;
  --c-text: #1f2937;
  --c-text-light: #6b7280;
  --c-border: #e5e7eb;
  --radius: 8px;
  --shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

/* ---------- Overlay ---------- */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1.5rem;
}

/* ---------- Container ---------- */
.procedures-modal.payment-modal {
  background: var(--c-bg);
  width: 1100px;
  max-width: 100%;
  max-height: 90vh;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  display: flex;
  flex-direction: column;
}

/* ---------- Header ---------- */
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--c-border);
}

.modal-header h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--c-text);
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--c-text-light);
  transition: color 0.2s;
}
.close-button:hover {
  color: var(--c-text);
}

/* ---------- Scrollable content ---------- */
.modal-content-scrollable {
  padding: 1.5rem;
  overflow-y: auto;
  flex: 1 1 auto;
}

/* ---------- Patient Info ---------- */
.payment-patient-info {
  display: flex;
  gap: 2rem;
  margin-bottom: 1.25rem;
  font-size: 0.95rem;
}
.payment-patient-info span {
  color: var(--c-text-light);
  margin-right: 0.25rem;
}

/* ---------- Search ---------- */
.payment-search-container {
  margin-bottom: 1rem;
}
.search-input {
  display: flex;
  align-items: center;
  background: var(--c-bg-alt);
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius);
}
.search-input svg {
  margin-right: 0.5rem;
  color: var(--c-text-light);
}
.search-input input {
  flex: 1 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 0.95rem;
}

/* ---------- Selection ---------- */
.select-all-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  -webkit-user-select: none;
          user-select: none;
}

/* ---------- Procedures List ---------- */
.payment-procedures-list {
  border: 1px solid var(--c-border);
  border-radius: var(--radius);
  max-height: 350px;
  overflow-y: auto;
}

.payment-procedure-item {
  display: grid;
  grid-template-columns: 1fr 4fr 2fr 3fr 1fr;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--c-border);
  cursor: pointer;
  transition: background 0.15s;
}
.payment-procedure-item:last-child {
  border-bottom: none;
}
.payment-procedure-item:hover {
  background: var(--c-bg-alt);
}
.payment-procedure-item.selected {
  background: rgba(37, 99, 235, 0.08);
}
/* .payment-procedure-item.paid {
  display: flex;
  opacity: 0.65;
} */
.payment-procedure-item.paid {
  display: grid;
  /* grid-template-columns: 48px 24px 1fr 36px 36px 1fr auto; */
  grid-template-columns: 1fr 4fr 1fr 1fr 3fr 1fr;
  align-items: center;
  gap: 1rem;
  opacity: 0.65;
}

.payment-procedure-checkbox input {
  width: 20px;
  height: 20px;
  accent-color: var(--c-primary);
}

.payment-procedure-details h4 {
  margin: 0;
  font-size: 0.95rem;
  color: var(--c-text);
  font-weight: 500;
}
.payment-procedure-code {
  font-size: 0.8rem;
  color: var(--c-text-light);
}

.payment-procedure-company {
  text-align: right;
  margin-right: 1rem;
}

.payment-procedure-company-not-paid{
  margin-right: 2rem;
}

.payment-procedure-price {
  font-weight: 600;
  color: var(--c-text);
  text-align: right;
}

/* ---------- Summary ---------- */
.payment-summary {
  margin-top: 1.5rem;
  border-top: 1px solid var(--c-border);
  padding-top: 1.25rem;
}

.payment-subtotal,
.payment-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
  margin-bottom: 0.75rem;
}
.payment-total strong {
  font-size: 1.2rem;
  color: var(--c-primary);
}

/* ---------- Discount ---------- */
.payment-discount-section {
  background: var(--c-bg-alt);
  padding: 1rem;
  border-radius: var(--radius);
  margin: 1rem 0;
}

.payment-discount-section h4 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: .75rem;
  color: var(--text-secondary);
}

.discount-type-selector {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.discount-type-selector label {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.discount-type-selector input {
  accent-color: var(--c-primary);
}

.payment-discount-section input[type="number"] {
  width: 25%;
  padding: 0.4rem 0.55rem;
  font-size: 0.9rem;
  border: 1px solid var(--c-border);
  border-radius: var(--radius);
}

.payment-discount-section label {
  display: block;
  font-size: 0.8rem;
  color: var(--c-text-light);
  margin-top: 0.75rem;
}

/* ---------- Payment Methods ---------- */
.payment-methods-container h3 {
  margin-top: 1.5rem;
  font-size: 1rem;
}
.payment-row {
  display: grid;
  grid-template-columns: 160px 1fr 80px auto;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 0.75rem;
}
.payment-row select,
.payment-row input[type="number"] {
  padding: 0.4rem 0.55rem;
  font-size: 0.9rem;
  border: 1px solid var(--c-border);
  border-radius: var(--radius);
}
.payment-row button {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--c-danger);
}

.add-payment-button {
  margin-top: 0.5rem;
  background: none;
  border: 1px dashed var(--c-primary);
  color: var(--c-primary);
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius);
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.2s;
}
.add-payment-button:hover {
  background: rgba(37, 99, 235, 0.08);
}

/* ---------- Receipt Upload ---------- */
.payment-receipt-upload {
  margin-top: 1.5rem;
}
.upload-button {
  background: var(--c-primary);
  color: #fff;
  border: none;
  padding: 0.55rem 1rem;
  border-radius: var(--radius);
  cursor: pointer;
  font-size: 0.9rem;
}
.upload-button svg {
  margin-right: 0.35rem;
}
.receipt-preview {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--c-bg-alt);
  border: 1px solid var(--c-border);
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius);
}
.receipt-preview img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: var(--radius);
}
.receipt-preview-success,
.receipt-preview-confirmation {
  width: 180px;
  border-radius: var(--radius);
  object-fit: cover;
  margin-top: 0.5rem;
}

.file-input-hidden {
  display: none;
}

/* ---------- Footer & Buttons ---------- */
.modal-footer {
  border-top: 1px solid var(--c-border);
  padding: 1rem 1.5rem;
  background: var(--c-bg-alt);
}
.payment-actions,
.payment-confirmation-actions,
.payment-success-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

button.cancel-button,
button.back-button {
  background: none;
  border: 1px solid var(--c-border);
  color: var(--c-text);
  padding: 0.5rem 0.9rem;
  border-radius: var(--radius);
  cursor: pointer;
  font-size: 0.9rem;
}
button.process-payment-button,
button.confirm-payment-button,
button.confirm-refund-button,
button.print-receipt-button,
button.close-success-button {
  background: var(--c-primary);
  color: #fff;
  border: none;
  padding: 0.55rem 1.1rem;
  border-radius: var(--radius);
  cursor: pointer;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}
button.confirm-refund-button {
  background: var(--c-danger);
}
button.process-payment-button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ---------- Confirmation / Success ---------- */
.payment-confirmation-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  background: var(--c-bg-alt);
  padding: 0.75rem 1rem;
  border-radius: var(--radius);
}
.payment-confirmation-header svg {
  color: var(--c-primary);
}

.payment-confirmation-details h3 {
  margin: 1.2rem 0 0.5rem;
  font-size: 1rem;
}
.payment-list {
  list-style: none;
  padding: 0;
  margin: 0.25rem 0 0.75rem;
}
.payment-list li {
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
}

.payment-success {
  text-align: center;
  padding: 2rem 1rem;
}
.payment-success-icon svg {
  color: var(--c-primary);
}
.payment-success h3 {
  margin-top: 1rem;
  font-size: 1.25rem;
}

@media (max-width: 640px) {
  .procedures-modal.payment-modal {
    width: 100%;
    height: 100vh;
    max-height: none;
    border-radius: 0;
  }
  .payment-row {
    grid-template-columns: 1fr 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/newPosConsult/css/payment-modal.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA,oCAAoC;AACpC;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB,EAAE,SAAS;EAC/B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mCAAmC;AACrC;AACA;;;GAGG;AACH;EACE,aAAa;EACb,6DAA6D;EAC7D,8CAA8C;EAC9C,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;EAC3B,aAAa;EACb,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;AACA;;EAEE,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,mCAAmC;AACrC;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,iCAAiC;EACjC,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;;EAEE,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,2CAA2C;AAC3C;EACE,qCAAqC;EACrC,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;;;EAGE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,iCAAiC;EACjC,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;AACA;;;;;EAKE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".select-fee-button {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  background-color: #f8f9fa;\n  border: 1px solid #ccc;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: box-shadow 0.2s;\n}\n\n.select-fee-button:hover {\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n/*Confirmar pagamento*/\n.payment-confirmation-container {\n  background-color: #f9fafb;\n  border-radius: 12px;\n  padding: 24px;\n  margin-top: 20px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);\n}\n\n.confirmation-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n.icon-alert {\n  color: #f59e0b;\n}\n\n.confirmation-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.confirmation-section {\n  margin-bottom: 20px;\n}\n\n.section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 10px;\n}\n\n.payment-list {\n  list-style: none;\n  padding-left: 0;\n  margin: 0;\n}\n\n.payment-list li {\n  padding: 4px 0;\n  color: #374151;\n}\n\n.totals p {\n  font-size: 15px;\n  color: #111827;\n}\n\n.total-line {\n  font-size: 16px;\n  font-weight: 700;\n  color: #10b981;\n}\n\n/*Comprovantes*/\n.receipt-list {\n  margin-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.receipt-item {\n  position: relative;\n  width: 300px;\n  height: 300px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.receipt-item img {\n  width: 200px;\n  height: 200px;\n}\n\n.receipt-item button {\n  background: #f71836;\n  border: none;\n  border-radius: 50%;\n  padding: .75rem;\n  cursor: pointer;\n}\n\n/* proced. selecionado p/ extorno */\n.payment-procedure-item.paid.selected {\n  border: 1px solid #d9534f;\n  background: rgba(217, 83, 79, 0.1);\n}\n\n/* botão extorno */\n.confirm-refund-button {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  padding: 8px 14px;\n  border: none;\n  border-radius: 4px;\n  color: #fff;\n  font-weight: 500;\n  cursor: pointer;\n}\n/* ---------- Variáveis ---------- */\n:root {\n  --c-bg: #ffffff;\n  --c-bg-alt: #f6f8fa;\n  --c-primary: #2563eb; /* azul */\n  --c-primary-light: #3b82f6;\n  --c-danger: #d9534f;\n  --c-text: #1f2937;\n  --c-text-light: #6b7280;\n  --c-border: #e5e7eb;\n  --radius: 8px;\n  --shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n}\n\n/* ---------- Overlay ---------- */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n  padding: 1.5rem;\n}\n\n/* ---------- Container ---------- */\n.procedures-modal.payment-modal {\n  background: var(--c-bg);\n  width: 1100px;\n  max-width: 100%;\n  max-height: 90vh;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  display: flex;\n  flex-direction: column;\n}\n\n/* ---------- Header ---------- */\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--c-border);\n}\n\n.modal-header h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--c-text);\n}\n\n.close-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--c-text-light);\n  transition: color 0.2s;\n}\n.close-button:hover {\n  color: var(--c-text);\n}\n\n/* ---------- Scrollable content ---------- */\n.modal-content-scrollable {\n  padding: 1.5rem;\n  overflow-y: auto;\n  flex: 1 1 auto;\n}\n\n/* ---------- Patient Info ---------- */\n.payment-patient-info {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 1.25rem;\n  font-size: 0.95rem;\n}\n.payment-patient-info span {\n  color: var(--c-text-light);\n  margin-right: 0.25rem;\n}\n\n/* ---------- Search ---------- */\n.payment-search-container {\n  margin-bottom: 1rem;\n}\n.search-input {\n  display: flex;\n  align-items: center;\n  background: var(--c-bg-alt);\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius);\n}\n.search-input svg {\n  margin-right: 0.5rem;\n  color: var(--c-text-light);\n}\n.search-input input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 0.95rem;\n}\n\n/* ---------- Selection ---------- */\n.select-all-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  user-select: none;\n}\n\n/* ---------- Procedures List ---------- */\n.payment-procedures-list {\n  border: 1px solid var(--c-border);\n  border-radius: var(--radius);\n  max-height: 350px;\n  overflow-y: auto;\n}\n\n.payment-procedure-item {\n  display: grid;\n  grid-template-columns: 1fr 4fr 2fr 3fr 1fr;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--c-border);\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.payment-procedure-item:last-child {\n  border-bottom: none;\n}\n.payment-procedure-item:hover {\n  background: var(--c-bg-alt);\n}\n.payment-procedure-item.selected {\n  background: rgba(37, 99, 235, 0.08);\n}\n/* .payment-procedure-item.paid {\n  display: flex;\n  opacity: 0.65;\n} */\n.payment-procedure-item.paid {\n  display: grid;\n  /* grid-template-columns: 48px 24px 1fr 36px 36px 1fr auto; */\n  grid-template-columns: 1fr 4fr 1fr 1fr 3fr 1fr;\n  align-items: center;\n  gap: 1rem;\n  opacity: 0.65;\n}\n\n.payment-procedure-checkbox input {\n  width: 20px;\n  height: 20px;\n  accent-color: var(--c-primary);\n}\n\n.payment-procedure-details h4 {\n  margin: 0;\n  font-size: 0.95rem;\n  color: var(--c-text);\n  font-weight: 500;\n}\n.payment-procedure-code {\n  font-size: 0.8rem;\n  color: var(--c-text-light);\n}\n\n.payment-procedure-company {\n  text-align: right;\n  margin-right: 1rem;\n}\n\n.payment-procedure-company-not-paid{\n  margin-right: 2rem;\n}\n\n.payment-procedure-price {\n  font-weight: 600;\n  color: var(--c-text);\n  text-align: right;\n}\n\n/* ---------- Summary ---------- */\n.payment-summary {\n  margin-top: 1.5rem;\n  border-top: 1px solid var(--c-border);\n  padding-top: 1.25rem;\n}\n\n.payment-subtotal,\n.payment-total {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 1rem;\n  margin-bottom: 0.75rem;\n}\n.payment-total strong {\n  font-size: 1.2rem;\n  color: var(--c-primary);\n}\n\n/* ---------- Discount ---------- */\n.payment-discount-section {\n  background: var(--c-bg-alt);\n  padding: 1rem;\n  border-radius: var(--radius);\n  margin: 1rem 0;\n}\n\n.payment-discount-section h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: .75rem;\n  color: var(--text-secondary);\n}\n\n.discount-type-selector {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 0.75rem;\n}\n\n.discount-type-selector label {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  cursor: pointer;\n  user-select: none;\n}\n\n.discount-type-selector input {\n  accent-color: var(--c-primary);\n}\n\n.payment-discount-section input[type=\"number\"] {\n  width: 25%;\n  padding: 0.4rem 0.55rem;\n  font-size: 0.9rem;\n  border: 1px solid var(--c-border);\n  border-radius: var(--radius);\n}\n\n.payment-discount-section label {\n  display: block;\n  font-size: 0.8rem;\n  color: var(--c-text-light);\n  margin-top: 0.75rem;\n}\n\n/* ---------- Payment Methods ---------- */\n.payment-methods-container h3 {\n  margin-top: 1.5rem;\n  font-size: 1rem;\n}\n.payment-row {\n  display: grid;\n  grid-template-columns: 160px 1fr 80px auto;\n  gap: 0.75rem;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n.payment-row select,\n.payment-row input[type=\"number\"] {\n  padding: 0.4rem 0.55rem;\n  font-size: 0.9rem;\n  border: 1px solid var(--c-border);\n  border-radius: var(--radius);\n}\n.payment-row button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--c-danger);\n}\n\n.add-payment-button {\n  margin-top: 0.5rem;\n  background: none;\n  border: 1px dashed var(--c-primary);\n  color: var(--c-primary);\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background 0.2s;\n}\n.add-payment-button:hover {\n  background: rgba(37, 99, 235, 0.08);\n}\n\n/* ---------- Receipt Upload ---------- */\n.payment-receipt-upload {\n  margin-top: 1.5rem;\n}\n.upload-button {\n  background: var(--c-primary);\n  color: #fff;\n  border: none;\n  padding: 0.55rem 1rem;\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n.upload-button svg {\n  margin-right: 0.35rem;\n}\n.receipt-preview {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: var(--c-bg-alt);\n  border: 1px solid var(--c-border);\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius);\n}\n.receipt-preview img {\n  width: 48px;\n  height: 48px;\n  object-fit: cover;\n  border-radius: var(--radius);\n}\n.receipt-preview-success,\n.receipt-preview-confirmation {\n  width: 180px;\n  border-radius: var(--radius);\n  object-fit: cover;\n  margin-top: 0.5rem;\n}\n\n.file-input-hidden {\n  display: none;\n}\n\n/* ---------- Footer & Buttons ---------- */\n.modal-footer {\n  border-top: 1px solid var(--c-border);\n  padding: 1rem 1.5rem;\n  background: var(--c-bg-alt);\n}\n.payment-actions,\n.payment-confirmation-actions,\n.payment-success-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\nbutton.cancel-button,\nbutton.back-button {\n  background: none;\n  border: 1px solid var(--c-border);\n  color: var(--c-text);\n  padding: 0.5rem 0.9rem;\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-size: 0.9rem;\n}\nbutton.process-payment-button,\nbutton.confirm-payment-button,\nbutton.confirm-refund-button,\nbutton.print-receipt-button,\nbutton.close-success-button {\n  background: var(--c-primary);\n  color: #fff;\n  border: none;\n  padding: 0.55rem 1.1rem;\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-size: 0.9rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\nbutton.confirm-refund-button {\n  background: var(--c-danger);\n}\nbutton.process-payment-button[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ---------- Confirmation / Success ---------- */\n.payment-confirmation-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  background: var(--c-bg-alt);\n  padding: 0.75rem 1rem;\n  border-radius: var(--radius);\n}\n.payment-confirmation-header svg {\n  color: var(--c-primary);\n}\n\n.payment-confirmation-details h3 {\n  margin: 1.2rem 0 0.5rem;\n  font-size: 1rem;\n}\n.payment-list {\n  list-style: none;\n  padding: 0;\n  margin: 0.25rem 0 0.75rem;\n}\n.payment-list li {\n  font-size: 0.9rem;\n  margin-bottom: 0.35rem;\n}\n\n.payment-success {\n  text-align: center;\n  padding: 2rem 1rem;\n}\n.payment-success-icon svg {\n  color: var(--c-primary);\n}\n.payment-success h3 {\n  margin-top: 1rem;\n  font-size: 1.25rem;\n}\n\n@media (max-width: 640px) {\n  .procedures-modal.payment-modal {\n    width: 100%;\n    height: 100vh;\n    max-height: none;\n    border-radius: 0;\n  }\n  .payment-row {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
